import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/ColorProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/ProductResources/ProductResourcesUserManuals/ProductResourcesUserManuals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/ProductResources/Toast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/Products/ImageViewer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/Products/ProductDetails/ProductDetailsCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/Products/ProductDetails/ProductDetailsDescription/ProductDetailsDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/apps/web/src/components/Products/ProductDetails/ProductDetailsSticky/ProductDetailsSticky.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UnitProvider"] */ "/opt/render/project/src/apps/web/src/contexts/unitContext.tsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/packages/uikit/src/components/atoms/Tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollSpy"] */ "/opt/render/project/src/packages/uikit/src/components/molecules/ScrollSpy.tsx");
